import { TOrderEntryFormValues, TOrderEntrySettings } from './types'

const defaultSettings: TOrderEntrySettings = {
  id: 'defaultOrderEntry',
  hazmatUrl: 'api/hazmat/search',
  barcodeUrl: 'api/validate',
  reusableBoxUrl: 'api/validateReusableBox',
  customsUrl: 'api/customs',
  addressbookUrl: 'api/addressbook',
  providers: [],
  initialValues: {} as TOrderEntryFormValues,
  preset: {},
  requestSubmit: async () => {
    await new Promise<void>((resolve) => {
      resolve()
    })
  },
}

export default defaultSettings
